import axios from 'axios';

// credential = the ID token Google's button hands back; the backend verifies it.
// Returns the request so the login form can stop its spinner.
export const signIn = ({ credential }) => {
  return (dispatch, getState) => {
    return axios({
      url: process.env.REACT_APP_API_URL+'/login/google',
      method: 'post',
      data: {
        credential
      },
      withCredentials:true
    }).then((res) => {
      if (res.data.success === 1) {
        dispatch({ type: 'LOGIN_SUCCESS', payload: { data: res.data.data } });
      } else {
        dispatch({ type: 'LOGIN_ERROR', err: res.data.msg });
      }
    }).catch((err) => {
      dispatch({ type: 'LOGIN_ERROR', err: err.message });
    });
  }
}

export const signOut = () => {
  return (dispatch) => {
    axios({
      url: process.env.REACT_APP_API_URL+'/login/logout',
      method: 'post',
      withCredentials:true
    }).then((res) => {
      if (res.data.success === 1) {
        dispatch({ type: 'SIGNOUT_SUCCESS' });
      }
    })
  }
}